import {
  Button,
  CircularProgress,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import DocumentTable from "../../../components/OB/BelgeYukleme";
import GayrimenkulBulPopUp from "../../../components/OB/PopUp";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import BinaBasvuruSave from "../../../apis/OB/SaveApi/BinaBasvuruSave";
import { katiAtikValidationSchema } from "../../../validations/EmlakBasvuru";
import KullanimSekliListeAPI from "../../../apis/OB/Get/KullanimSekliListeAPI";
import { safelyParseNumber } from "../../../helpers/MoneyFormat";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import InsaatSinifiAPI from "../../../apis/OB/Get/InsaatSinifiAPI";
import InsaatTuruAPI from "../../../apis/OB/Get/InsaatTuruAPI";
import CtvKriterBulAPI from "../../../apis/OB/Get/CtvKriterBulAPI";
import CtvSbitBilgiGetAPI from "../../../apis/OB/Get/CtvSbitBilgiGetAPI";
import FaaliyetListeAPI from "../../../apis/OB/Get/FaaliyetListeAPI";
import CtvKullanimListeAPI from "../../../apis/OB/Get/CtvKullanimListeAPI";
import KatKullanimListeAPI from "../../../apis/OB/Get/KatKullanimListeAPI";
import KatBasvuruSave from "../../../apis/OB/SaveApi/KatBasvuruSave";
import CtvBasvuruave from "../../../apis/OB/SaveApi/CtvBasvuruave";
import SessionStorageService from "../../../services/StorageService";
import { useNavigate } from "react-router";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import CustomTextField from "../../../components/OB/required-text-field";
import CustomDatePicker from "../../../components/OB/required-datepicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import Recaptcha from "../../../components/Recaptcha";
import DysAPI from "../../../apis/DysAPI";

const KatiAtikBasvuru = (props: any) => {
  const recaptchaRef = useRef<any>(null);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);
  const [open, setOpen] = useState(false);
  const openPopup = () => {
    setOpen(true);
  };
  const [kullanimSekliKoduList, setkullanimSekliKoduList] = useState<any[]>([]);

  useEffect(() => {
    if (props.basvuruTuruId === 4) {
      CtvKullanimListeAPI.getCtvKullanimListe(undefined)
        .then((response) => {
          console.log(response.data);
          setkullanimSekliKoduList(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      KatKullanimListeAPI.getKatKullanimListe(undefined)
        .then((response) => {
          const data = response.data;
          setkullanimSekliKoduList(Array.isArray(data) ? data.map((item: any) => ({
            katKullanimSekliKodu: item.katKullanımSekliKodu ?? item.katKullanimSekliKodu,
            katKullanimSekliAdi: item.katKullanımSekliAdi ?? item.katKullanimSekliAdi,
          })) : []);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  const { mahalleListe } = useContext(ConstantAPISContext);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupAciklama, setPopupAciklama] = useState("");
  const [kayitBasarili, setKayitBasarili] = useState(false);
  const user = SessionStorageService.getUserInfo()
  const [userControlPopup, setUserControlPopup] = useState(false);
  const navigate = useNavigate();
  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate(-1);
  }
  const [isLoad, setIsLoad] = useState(true);
  useEffect(() => {

    if (user == null) {

      setUserControlPopup(true);
    } else {
      setIsLoad(false);
    }

  }, []);
  const closePopupSonuc = () => {
    setIsPopupVisible(false);
    setPopupAciklama("");
  };
  const closePopup = () => {
    setOpen(false);
  };
  const [selectedMahalleKodu, setSelectedMahalleKodu] = useState<number | null>(
    null
  );
  const [CtvKullanimListeAPIResponse, setCtvKullanimListeAPIResponse] =
    useState<any>([]);
  const [CtvSbitBilgiGetAPIResponse, setCtvSbitBilgiGetAPIResponse] =
    useState<any>([]);
  const [CtvKriterBulAPIResponse, setCtvKriterBulAPIResponse] = useState<any>(
    null
  );
  const [faaliyetListe, setFaaliyetListe] = useState<any[]>([]);

  const [documents, setDocuments] = useState<any[]>([]);
  const [docsLoaded, setDocsLoaded] = useState<boolean>(false);
  const documentTableRef = useRef<HTMLDivElement | null>(null);

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  const handleUpdateDocuments = (updatedDocuments: any) => {
    setDocuments(updatedDocuments);
  };
  useEffect(() => {
    setDocsLoaded(false);

    DysAPI.obBasvuruTanimBelgeList({ rfObBasvuruTanim: props.basvuruTuruId })
      .then((res: any) => {
        console.log("Belge listesi response:", res.data);

        const list = (res?.data ?? []).map((b: any, idx: number) => {
          const zorunlu = (b.zorunluEh)
            .toString();

          return {
            id: b.sqId,
            documentName: b.belgeAdi,
            isRequired: ["E"].includes(zorunlu),
            fileName: "",
            file: null,
          };
        });


        setDocuments(list);
      })
      .catch((err: any) => {
        console.error("Belge listesi hatası:", err);
        setDocuments((prevDocs: any[]) =>
          prevDocs.map((doc) => ({
            ...doc,
            file: null,
            fileName: "",
          }))
        );
      })
      .finally(() => {
        setDocsLoaded(true);
      });
  }, []);

  useEffect(() => {
    if (user) {
      CtvSbitBilgiGetAPI.getCtvSabitBilgiGet()
        .then((response) => {
          setCtvSbitBilgiGetAPIResponse(response.data[0]);
        })
        .catch((error) => { });
      FaaliyetListeAPI.getFaaliyetListe(undefined)
        .then((response) => {
          console.log(response.data);
          setFaaliyetListe(response.data);
        })
        .catch((error) => { });
        CtvKullanimListeAPI.getCtvKullanimListe(undefined)
        .then((response) => {
          setCtvKullanimListeAPIResponse(response.data);
        })
        .catch((error) => { });
    }
  }, []);

  const [caddeListe, setCaddeListe] = useState<any[]>([]);
  useEffect(() => {
    if (selectedMahalleKodu) {
      CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalleKodu)
        .then((res) => {
          setCaddeListe(res.data);
        })
        .catch(() => {
          console.log("hata");
        })
        .finally(() => { });
    } else {
      setCaddeListe([]);
    }
  }, [selectedMahalleKodu]);

  return (
    isLoad ? <>
      <div className="d-flex align-self-strech justify-content-center align-items-center"> <CircularProgress /></div>
      {userControlPopup ? (

        <AciklamaAndUserControlPopup
          open={userControlPopup}
          handleClose={closeUserControlPopup}
          isUserControlPopUp={true}
          description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
        />

      ) : null}
    </> :
      <Formik
        validateOnMount={true}
        validationSchema={katiAtikValidationSchema}
        initialValues={{
          basvuruTuruId: props.basvuruTuruId,
          sicilKodu: user?.sicilKodu,
          mahalleKodu: "",
          caddeSokakKodu: "",
          kapiNo: "",
          altKapiNo: "",
          daireNo: "",
          altDaireNo: "",
          siteApartmanAdi: "",
          blokKatNo: "",
          pafta: "",
          ada: "",
          parsel: "",
          isyeriAcmaTarihi: null,
          faaliyetKodu: "",
          kullanimSekliKodu: null,
          kriterKodu: null,
          m2: "",
          ogrenciSayisi: "",
          koltukSayisi: "",
          personelSayisi: "",
          yatakSayisi: "",
          ctvGrup: "",
          ctvDerece: "",
          aciklama: "",
          kaloriferliMi: "H",
        }}
        onSubmit={async (values: any, { resetForm }) => {
          const missingDocuments = documents
            .filter(doc => doc.isRequired) // zorunlu belgeler
            .filter(doc => !doc.fileName);     // henüz yüklenmemiş olanlar

          if (missingDocuments.length > 0) {
            const missingDocNames = missingDocuments.map(d => d.documentName).join(", ");
            toast.error(`Lütfen şu zorunlu belgeleri yükleyin: ${missingDocNames}`);
            documentTableRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
            return; // başvuru burada durur
          }

          // reCAPTCHA’yı tetikle
          const token = await recaptchaRef.current?.handleSubmit();
          if (!token) {
            toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
            return;
          }

          setLoadingSubmit(true);
          const transformedValues = {
            ...values,
            basvuruTuruId: safelyParseNumber(values.basvuruTuruId),
            mahalleKodu: safelyParseNumber(values.mahalleKodu),
            caddeSokakKodu: safelyParseNumber(values.caddeSokakKodu),
            sicilKodu: safelyParseNumber(values.sicilKodu) || 0,
            daireNo: values.daireNo != "" ? safelyParseNumber(values.daireNo) : null,
            ada: values.ada != "" ? safelyParseNumber(values.ada) : null,
            parsel: values.parsel != "" ? safelyParseNumber(values.parsel) : null,
            m2: safelyParseNumber(values.m2),
            ogrenciSayisi: safelyParseNumber(values.ogrenciSayisi),
            koltukSayisi: safelyParseNumber(values.koltukSayisi),
            personelSayisi: safelyParseNumber(values.personelSayisi),
            yatakSayisi: safelyParseNumber(values.yatakSayisi),
            isyeriAcmaTarihi: dayjs(values.isyeriAcmaTarihi).tz("Europe/Istanbul").format("YYYY-MM-DD"),
            kullanimSekliKodu: safelyParseNumber(values.kullanimSekliKodu),
            captchaToken: token
          };
          console.log("transformedvalue", transformedValues)
          if (props.basvuruTuruId === 4) {
            CtvBasvuruave.saveCtvBasvuruSave(transformedValues)
              .then(async (res) => {
                console.log(res);
                if (res.data.sonuc === 0) {
                  let basvuruNo = res.data.basvuruNo;

                  // DYS API'yi çağır 
                  try {
                    // Sadece dosyası olanları al
                    const filesToSend = documents.filter((doc: any) => !!doc.file);

                    if (filesToSend.length > 0) {
                      const formData = new FormData();

                      filesToSend.forEach((doc: any) => {
                        formData.append("files", doc.file, doc.file.name);
                        formData.append("rfObBasvuruTanimBelge", String(doc.id));
                      });

                      formData.append("basvuruTuru", String(values.basvuruTuruId || 0));
                      formData.append("basvuruId", String(basvuruNo));
                      formData.append("folderName", "AKOS");
                      formData.append("kurumId", "1");
                      formData.append("versionable", "1");

                      const response = await DysAPI.upload(formData);
                      toast.warning(response.message);
                    } else {
                      // Burada return yok — sadece DYS çağrısını atlıyoruz.
                      
                    }
                  } catch (error: any) {
                    toast.error("DYS upload hazırlama hatası:", error);
                  }

                  setPopupAciklama(
                    "İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " +
                    basvuruNo
                  );
                  resetForm();
                  setDocuments((prevDocs: any[]) =>
                    prevDocs.map((doc) => ({
                      ...doc,
                      file: null,
                      fileName: "",
                    }))
                  );
                  setKayitBasarili(true);
                } else {
                  setPopupAciklama(res.data.sonucAciklama);
                }
              })
              .catch((err) => {
                setPopupAciklama(
                  "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
                );
              })
              .finally(() => {
                setIsPopupVisible(true);
                recaptchaRef.current?.reset();
                setLoadingSubmit(false);
              });
          } else {
            KatBasvuruSave.saveKatBasvuruSave(transformedValues)
              .then(async (res) => {
                console.log(res);
                if (res.data.sonuc === 0) {
                  let basvuruNo = res.data.basvuruNo;

                  // DYS API'yi çağır 
                  try {
                    // Sadece dosyası olanları al
                    const filesToSend = documents.filter((doc: any) => !!doc.file);

                    if (filesToSend.length > 0) {
                      const formData = new FormData();

                      filesToSend.forEach((doc: any) => {
                        formData.append("files", doc.file, doc.file.name);
                        formData.append("rfObBasvuruTanimBelge", String(doc.id));
                      });

                      formData.append("basvuruTuru", String(values.basvuruTuruId || 0));
                      formData.append("basvuruId", String(basvuruNo));
                      formData.append("folderName", "AKOS");
                      formData.append("kurumId", "1");
                      formData.append("versionable", "1");

                      const response = await DysAPI.upload(formData);
                      toast.warning(response.message);
                    } else {
                      // Burada return yok — sadece DYS çağrısını atlıyoruz.
                      
                    }
                  } catch (error: any) {
                    toast.error("DYS upload hazırlama hatası:", error);
                  }

                  setPopupAciklama(
                    "İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " +
                    basvuruNo
                  );
                  resetForm();
                  setDocuments((prevDocs: any[]) =>
                    prevDocs.map((doc) => ({
                      ...doc,
                      file: null,
                      fileName: "",
                    }))
                  );
                  setKayitBasarili(true);
                } else {
                  setPopupAciklama(res.data.sonucAciklama);
                }
              })
              .catch((err) => {
                setPopupAciklama(
                  "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
                );
              })
              .finally(() => {
                setIsPopupVisible(true);
                recaptchaRef.current?.reset();
                setLoadingSubmit(false);
              });
          }
        }}
      >
        {(formikProps) => {
          // eslint-disable-next-line react-hooks/rules-of-hooks       
          useEffect(() => {
            console.log(formikProps.values.kullanimSekliKodu);
            if (formikProps.values.kullanimSekliKodu != null) {
              CtvKriterBulAPI.getCtvKriterBul(
                formikProps.values.kullanimSekliKodu
              )
                .then((response) => {
                  console.log(response.data[0]);
                  setCtvKriterBulAPIResponse(response.data[0]);
                  formikProps.setFieldValue(
                    "kriterKodu",
                    response.data[0].kriterKodu
                  );
                })
                .catch((error) => { });
            }
          }, [formikProps.values.kullanimSekliKodu]);
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            if (formikProps.values.kriterKodu != null) {
              switch (formikProps.values.kriterKodu) {
                case 1:
                  formikProps.setFieldValue("ogrenciSayisi", "");
                  formikProps.setFieldValue("koltukSayisi", "");
                  formikProps.setFieldValue("personelSayisi", "");
                  formikProps.setFieldValue("yatakSayisi", "");
                  break;
                case 2:
                  formikProps.setFieldValue("m2", "");
                  formikProps.setFieldValue("koltukSayisi", "");
                  formikProps.setFieldValue("personelSayisi", "");
                  formikProps.setFieldValue("yatakSayisi", "");
                  break;
                case 3:
                  formikProps.setFieldValue("ogrenciSayisi", "");
                  formikProps.setFieldValue("koltukSayisi", "");
                  formikProps.setFieldValue("personelSayisi", "");
                  formikProps.setFieldValue("m2", "");
                  break;
                case 4:
                  formikProps.setFieldValue("ogrenciSayisi", "");
                  formikProps.setFieldValue("koltukSayisi", "");
                  formikProps.setFieldValue("personelSayisi", "");
                  formikProps.setFieldValue("m2", "");
                  break;
                case 5:
                  formikProps.setFieldValue("ogrenciSayisi", "");
                  formikProps.setFieldValue("m2", "");
                  formikProps.setFieldValue("personelSayisi", "");
                  formikProps.setFieldValue("yatakSayisi", "");
                  break;
                default:
                  break;
              }
            }
          }, [formikProps.values.kriterKodu]);

          // eslint-disable-next-line react-hooks/rules-of-hooks
          const showToastIfErrorsExist = () => {
            if (Object.keys(formikProps.errors).length > 0) {
              focusFirstErrorField();
              toast.error("Lütfen zorunlu alanları doldurun!");

            }
          };
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const formRefs = useRef<any>({});
          const focusFirstErrorField = () => {
            const errorKeys = Object.keys(formikProps.errors);
            if (errorKeys.length > 0) {
              const firstErrorKey = errorKeys[0];
              console.log(errorKeys[0])
              const element = document.querySelector(`[name="${firstErrorKey}"]`);
              if (element) {
                (element as HTMLElement).focus();
              }
            }
          };

          return (
            <Form onSubmit={formikProps.handleSubmit}>
              <div className="row">
                <div className="col-12 mb-3">
                  <div className="d-flex justify-content-end align-self-stretch">
                    <Button

                      type="button"

                      onClick={() => {
                        formikProps.resetForm({ values: formikProps.initialValues });
                        setDocuments((prevDocs: any[]) =>
                          prevDocs.map((doc) => ({
                            ...doc,
                            file: null,
                            fileName: "",
                          }))
                        );
                      }}
                      color="secondary"

                    >

                      Temizle
                    </Button>
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-3 mb-lg-0">
                  <div className="card shadow-none border w-100">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-6">
                          <CustomTextField
                            name="mahalleKodu"
                            fullWidth
                            className="mb-3"
                            select
                            label="Mahalle *"
                            size="small"
                            error={
                              formikProps.errors.mahalleKodu &&
                                formikProps.touched.mahalleKodu
                                ? true
                                : false
                            }
                            value={formikProps.values.mahalleKodu}
                            onChange={(value: any) => {
                              formikProps.setFieldValue(
                                "mahalleKodu",
                                Number(value.target.value)
                              );
                              setSelectedMahalleKodu(Number(value.target.value));
                              formikProps.setFieldValue("caddeSokakKodu", null);
                            }}
                          >
                            <MenuItem selected value={null as any}>
                              {"Seçiniz.."}
                            </MenuItem>
                            {mahalleListe.map((option) => (
                              <MenuItem
                                key={option.mahalleKodu}
                                value={option.mahalleKodu}
                              >
                                {option.mahalleAdi}
                              </MenuItem>
                            ))}
                          </CustomTextField>
                        </div>
                        <div className="col-lg-6">
                          <CustomTextField
                            name="caddeSokakKodu"
                            fullWidth
                            className="mb-3"
                            size="small"
                            error={
                              formikProps.errors.caddeSokakKodu &&
                                formikProps.touched.caddeSokakKodu
                                ? true
                                : false
                            }
                            select
                            label="Cadde/Sokak *"
                            value={formikProps.values.caddeSokakKodu}
                            onChange={(value: any) =>
                              formikProps.setFieldValue(
                                "caddeSokakKodu",
                                Number(value.target.value)
                              )
                            }
                          >
                            <MenuItem selected value={null as any}>
                              {"Seçiniz.."}
                            </MenuItem>
                            {caddeListe.map((option) => (
                              <MenuItem
                                key={option.caddeSokakKodu}
                                value={option.caddeSokakKodu}
                              >
                                {option.caddeSokakAdi}
                              </MenuItem>
                            ))}
                          </CustomTextField>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <CustomTextField
                            name="kapiNo"
                            fullWidth
                            className="mb-3"
                            size="small"
                            error={
                              formikProps.errors.kapiNo &&
                                formikProps.touched.kapiNo
                                ? true
                                : false
                            }
                            label="Kapı No *"
                            value={formikProps.values.kapiNo}
                            onChange={(e: any) =>
                              formikProps.setFieldValue("kapiNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 4) : "")
                            }
                            variant="outlined"
                          />
                        </div>
                        <div className="col-lg-6">
                          <TextField
                            fullWidth
                            className="mb-3"
                            size="small"
                            label="Alt Kapı No"
                            error={
                              formikProps.errors.altKapiNo &&
                                formikProps.touched.altKapiNo
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("altKapiNo")}
                            variant="outlined"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <CustomTextField
                            name="daireNo"
                            fullWidth
                            className="mb-3"
                            size="small"
                            label="Daire No *"
                            error={
                              formikProps.errors.daireNo &&
                                formikProps.touched.daireNo
                                ? true
                                : false
                            }
                            value={formikProps.values.daireNo}
                            onChange={(e: any) =>
                              formikProps.setFieldValue("daireNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 4) : "")
                            }
                            variant="outlined"
                          />
                        </div>
                        <div className="col-lg-6">
                          <TextField
                            fullWidth
                            className="mb-3"
                            size="small"
                            label="Alt Daire No"
                            error={
                              formikProps.errors.altDaireNo &&
                                formikProps.touched.altDaireNo
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("altDaireNo")}
                            variant="outlined"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <TextField
                            fullWidth
                            className="mb-3"
                            size="small"
                            label="Site/Apartman Adı"
                            error={
                              formikProps.errors.siteApartmanAdi &&
                                formikProps.touched.siteApartmanAdi
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("siteApartmanAdi")}
                            variant="outlined"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-3">
                          <TextField
                            fullWidth
                            className="mb-3"
                            size="small"
                            label="Blok No/Kat No"
                            error={
                              formikProps.errors.blokKatNo &&
                                formikProps.touched.blokKatNo
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("blokKatNo")}
                            variant="outlined"
                          />
                        </div>

                        <div className="col-lg-3">
                          <TextField
                            fullWidth
                            className="mb-3"
                            size="small"
                            label="Pafta"
                            error={
                              formikProps.errors.pafta && formikProps.touched.pafta
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("pafta")}
                            variant="outlined"
                          />
                        </div>
                        <div className="col-lg-3">
                          <TextField
                            fullWidth
                            className="mb-3"
                            size="small"
                            label="Ada"
                            error={
                              formikProps.errors.ada && formikProps.touched.ada
                                ? true
                                : false
                            }
                            value={formikProps.values.ada}
                            onChange={(e: any) =>
                              formikProps.setFieldValue("ada", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 10) : "")
                            }
                            variant="outlined"
                          />
                        </div>
                        <div className="col-lg-3">
                          <TextField
                            fullWidth
                            className="mb-3"
                            size="small"
                            label="Parsel"
                            error={
                              formikProps.errors.parsel &&
                                formikProps.touched.parsel
                                ? true
                                : false
                            }
                            value={formikProps.values.parsel}
                            onChange={(e: any) =>
                              formikProps.setFieldValue("parsel", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 10) : "")
                            }
                            variant="outlined"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-lg-0">
                  <div className="card shadow-none border w-100">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-6">
                          <CustomDatePicker
                            name="isyeriAcmaTarihi"
                            slotProps={{
                              textField: {
                                size: "small", fullWidth: true,
                                error: formikProps.errors.isyeriAcmaTarihi && formikProps.touched.isyeriAcmaTarihi ? true : false
                              },
                            }}
                            label="İşyeri Açma Tarihi *"
                            value={formikProps.values.isyeriAcmaTarihi}
                            onChange={(value: any) =>
                              formikProps.setFieldValue("isyeriAcmaTarihi", value)
                            }
                            className="mb-3"
                          />
                        </div>
                        <div className="col-lg-6">
                          <CustomTextField
                            fullWidth
                            className="mb-3"
                            select
                            error={
                              formikProps.errors.faaliyetKodu &&
                                formikProps.touched.faaliyetKodu
                                ? true
                                : false
                            }
                            label="Faaliyet Adı *"
                            {...formikProps.getFieldProps("faaliyetKodu")}
                            size="small"
                          >
                            <MenuItem selected value={null as any}>
                              {"Seçiniz.."}
                            </MenuItem>
                            {faaliyetListe.map((item, number) => {
                              return (
                                <MenuItem key={number} value={item.faaliyetKodu}>
                                  {item.faaliyetAdi}
                                </MenuItem>
                              );
                            })}
                          </CustomTextField>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <CustomTextField
                            fullWidth
                            className="mb-3"
                            select
                            error={
                              formikProps.errors.kullanimSekliKodu &&
                                formikProps.touched.kullanimSekliKodu
                                ? true
                                : false
                            }
                            label="Kullanım Şekli *"
                            {...formikProps.getFieldProps("kullanimSekliKodu")}
                            size="small"
                          >
                            <MenuItem selected value={null as any}>
                              {"Seçiniz.."}
                            </MenuItem>
                            {kullanimSekliKoduList.map((item, number) => {
                              return (
                                <MenuItem
                                  key={number}
                                  value={props.basvuruTuruId === 4 ? item.ctvKullanimSekliKodu : item.katKullanimSekliKodu}
                                >
                                  {props.basvuruTuruId === 4 ? item.ctvKullanimSekliAdi : item.katKullanimSekliAdi}
                                </MenuItem>
                              );
                            })}
                          </CustomTextField>
                        </div>
                        <div className="col-lg-3">
                          <CustomTextField
                            name="kriterTuru"
                            fullWidth
                            className="mb-3"
                            size="small"
                            label="Kriter Türü *"
                            error={
                              formikProps.errors.kriterKodu &&
                                formikProps.touched.kriterKodu
                                ? true
                                : false
                            }
                            disabled={true}
                            value={
                              CtvKriterBulAPIResponse != null
                                ? CtvKriterBulAPIResponse.kriterKoduAciklama
                                : ""
                            }
                            variant="outlined"
                          />
                        </div>
                        <div className="col-lg-3">
                          <TextField
                            fullWidth
                            className="mb-3"
                            size="small"
                            disabled={
                              !(
                                CtvSbitBilgiGetAPIResponse.m2Kontrol == "H" ||
                                formikProps.values.kriterKodu == 1
                              )
                            }
                            label="M Kare"
                            error={
                              formikProps.errors.m2 && formikProps.touched.m2
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("m2")}
                            variant="outlined"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <TextField
                            fullWidth
                            className="mb-3"
                            size="small"
                            label="Öğrenci Sayısı"
                            disabled={formikProps.values.kriterKodu !== 3}
                            error={
                              formikProps.errors.ogrenciSayisi &&
                                formikProps.touched.ogrenciSayisi
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("ogrenciSayisi")}
                            variant="outlined"
                          />
                        </div>
                        <div className="col-lg-6">
                          <TextField
                            fullWidth
                            className="mb-3"
                            size="small"
                            label="Koltuk Sayısı"
                            disabled={formikProps.values.kriterKodu != 5}
                            error={
                              formikProps.errors.koltukSayisi &&
                                formikProps.touched.koltukSayisi
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("koltukSayisi")}
                            variant="outlined"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <TextField
                            fullWidth
                            disabled={formikProps.values.kriterKodu != 2}
                            className="mb-3"
                            size="small"
                            label="Personel Sayısı"
                            error={
                              formikProps.errors.personelSayisi &&
                                formikProps.touched.personelSayisi
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("personelSayisi")}
                            variant="outlined"
                          />
                        </div>
                        <div className="col-lg-6">
                          <TextField
                            fullWidth
                            className="mb-3"
                            disabled={formikProps.values.kriterKodu != 4}
                            size="small"
                            label="Yatak Sayısı"
                            error={
                              formikProps.errors.yatakSayisi &&
                                formikProps.touched.yatakSayisi
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("yatakSayisi")}
                            variant="outlined"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <TextField
                            fullWidth
                            className="mb-3"
                            size="small"
                            label="Grup"
                            disabled={
                              CtvSbitBilgiGetAPIResponse.ctvGrupDerece != "E"
                            }
                            error={
                              formikProps.errors.ctvGrup &&
                                formikProps.touched.ctvGrup
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("ctvGrup")}
                            variant="outlined"
                          />
                        </div>
                        <div className="col-lg-6">
                          <TextField
                            fullWidth
                            className="mb-3"
                            size="small"
                            label="Derece"
                            disabled={
                              CtvSbitBilgiGetAPIResponse.ctvGrupDerece != "E"
                            }
                            error={
                              formikProps.errors.ctvDerece &&
                                formikProps.touched.ctvDerece
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("ctvDerece")}
                            variant="outlined"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-4 mt-sm-2 mt-xxl-0 mb-lg-0">
                  <div className="card shadow-none border w-100">
                    <div className="card-body">
                      <div className="row">
                        <div className="row w-100 m-0 mb-3">
                          <div className="col-12 p-0 px-lg-0  mb-3 mb-lg-0">
                            <div className="card w-100">
                              <div className="card-body w-100">
                                <h5
                                  style={
                                    formikProps.errors.kaloriferliMi &&
                                      formikProps.touched.kaloriferliMi
                                      ? { color: "red" }
                                      : undefined
                                  }
                                >
                                  Kaloriferli mi?
                                </h5>
                                <RadioGroup
                                  aria-labelledby="demo-radio-buttons-group-label"
                                  {...formikProps.getFieldProps("kaloriferliMi")}
                                  row={true}
                                  defaultValue={formikProps.values.kaloriferliMi}
                                >
                                  <FormControlLabel
                                    value="E"
                                    control={<Radio />}
                                    style={
                                      formikProps.errors.kaloriferliMi &&
                                        formikProps.touched.kaloriferliMi
                                        ? { color: "red" }
                                        : undefined
                                    }
                                    label="Evet"
                                  />
                                  <FormControlLabel
                                    value="H"
                                    control={<Radio />}
                                    style={
                                      formikProps.errors.kaloriferliMi &&
                                        formikProps.touched.kaloriferliMi
                                        ? { color: "red" }
                                        : undefined
                                    }
                                    label="Hayır"
                                  />
                                </RadioGroup>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row pe-0">
                        <div className="col-12 pe-0">
                          <TextField
                            id="outlined-multiline-flexible"
                            label="Açıklama"
                            error={
                              formikProps.errors.aciklama &&
                                formikProps.touched.aciklama
                                ? true
                                : false
                            }
                            {...formikProps.getFieldProps("aciklama")}
                            rows={4.46}
                            fullWidth
                            multiline
                            maxRows={10}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div ref={documentTableRef}>
                  {!docsLoaded ? (
                    <div className="d-flex justify-content-center my-2"><CircularProgress size={24} /></div>
                  ) : (
                    <DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} />
                  )}
                </div>
                <div className="col-12 mt-3">
                  <div className="d-flex justify-content-end align-self-stretch">
                    <Recaptcha
                      ref={recaptchaRef}
                      changeHandleRecaptcha={setRecaptchaPassed}
                    />
                    <Button
                      onClick={() => showToastIfErrorsExist()}
                      type="submit"
                    >
                      Gönder
                    </Button>
                    {loadingSubmit && (
                      <div
                        style={{
                          position: "fixed",
                          inset: 0,
                          background: "rgba(255,255,255,0.6)",
                          zIndex: 1300,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <CircularProgress />
                      </div>
                    )}
                  </div>
                </div>
                {isPopupVisible ? (
                  <BilgilendirmePopup
                    basvuruTuruId={formikProps.values.basvuruTuruId}
                    isSorunBildirPopup={!kayitBasarili}
                    closePopup={closePopupSonuc}
                    open={isPopupVisible}
                    editDescription={popupAciklama}
                  />
                ) : null}
              </div>
            </Form>
          );
        }}
      </Formik>
  );
};

export default KatiAtikBasvuru;
